import React, { useContext } from 'react'
import { ConsentContext } from '../../context/ConsentContext'
import {
  BannerButton,
  BannerButtonGroup,
  BannerLink,
  BannerText,
  BannerWrapper,
} from './ConsentBanner.styles'

export const ConsentBanner = (): JSX.Element | null => {
  const { showBanner, accept, decline } = useContext(ConsentContext)

  if (!showBanner) return null

  return (
    <BannerWrapper role="dialog" aria-label="Cookie and tracking consent">
      <BannerText>
        We use cookies and similar tools for analytics and product monitoring.
        See our{' '}
        <BannerLink
          href="https://trustero.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </BannerLink>
        ,{' '}
        <BannerLink
          href="https://trustero.com/terms-of-use"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Use
        </BannerLink>
        , and{' '}
        <BannerLink
          href="https://trustero.com/our-commitment-to-secure-and-responsible-ai"
          target="_blank"
          rel="noreferrer"
        >
          Responsible AI Policy
        </BannerLink>
        .
      </BannerText>
      <BannerButtonGroup>
        <BannerButton onClick={decline}>Reject</BannerButton>
        <BannerButton onClick={accept}>Accept All</BannerButton>
      </BannerButtonGroup>
    </BannerWrapper>
  )
}
